var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMiniLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 32,
    viewBox: "0 0 48 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "logomark"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.6619 15.9999C16.6619 10.6745 27.1159 0 32.3311 0C37.5463 0 48 10.6745 48 15.9999C48 21.3252 37.5463 32 32.3311 32C27.1159 32 16.6619 21.3252 16.6619 15.9999ZM31.7057 28.0371C32.0512 28.3896 32.6109 28.3896 32.9562 28.0371L44.1193 16.6384C44.4645 16.2856 44.4645 15.7141 44.1193 15.3616L32.9562 3.96291C32.6109 3.61013 32.0512 3.61013 31.7057 3.96291L20.5428 15.3616C20.1976 15.7141 20.1976 16.2856 20.5428 16.6384L31.7057 28.0371Z",
    fill: "#00263A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.243313 3.90681L2.1882 1.92084C2.46352 1.63971 2.89122 1.59103 3.22144 1.80188C8.34399 5.07372 14.1669 12.0252 14.1669 15.9998C14.1669 19.9748 8.34399 26.9262 3.22144 30.198C2.89122 30.4089 2.46325 30.3599 2.18793 30.0788L0.244384 28.0942C-0.0807463 27.7622 -0.0807463 27.2237 0.244384 26.8917L10.2859 16.6384C10.6311 16.2856 10.6311 15.714 10.2859 15.3615L0.244384 5.1079C-0.0807463 4.77591 -0.0818176 4.2388 0.243313 3.90681Z",
    fill: "#00263A"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMiniLogo);
export default __webpack_public_path__ + "static/media/mini-logo.79a92a7deaed5492ffb269f990733962.svg";
export { ForwardRef as ReactComponent };